/**
 * Re-export all edit handlers
 */

export { EditContactHandler } from './edit-contact.handler';
export { EditCompanyHandler } from './edit-company.handler';
export { CreateContactActivityHandler } from './create-contact-activity.handler';
export { CreateDealHandler } from './create-deal.handler';
export { UpdateDealHandler } from './update-deal.handler';
export { MarkDealWonHandler } from './mark-deal-won.handler';
export { MarkDealLostHandler } from './mark-deal-lost.handler';
